import React, { Fragment, useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Modal,
  Grid,
  Typography,
  IconButton,
  Button,
  Divider,
  TextField,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import SpinnerSmall from "../../layout/SpinnerSmall";

import PaymentContext from "../../../context/paypal/payments/PaymentContext";

const PaymentActionModal = ({
  confirmModal,
  setConfirmModal,
  action,
  transaction_id,
  email,
  postOrderData,
}) => {
  const paymentContext = useContext(PaymentContext);
  const { loading, editCustomerInfo, postOrder, returned_posting } =
    paymentContext;

  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }

  const [isLoading, setIsLoading] = useState();
  const [header, setHeader] = useState("");
  const [headerWidth, setHeaderWidth] = useState(400);
  const [state, setState] = useState({
    email_value: email,
    errors: {
      email_value: "",
    },
  });

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: headerWidth,
      backgroundColor: "#F7F6F6",
      border: "0px solid #000",
      boxShadow: theme.shadows[5],
    },
    modalHeader: {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
    },
    modalBody: {
      padding: theme.spacing(2),
    },
    button: {
      width: 100,
    },
  }));

  const classes = useStyles();
  // getModalStyle is not a pure function, roll the style only on the first render
  const [modalStyle] = useState(getModalStyle);

  const handleClose = () => {
    setConfirmModal(false);
  };

  const onOK = () => {
    if (postOrderData) {
      postOrder(postOrderData, transaction_id);
      setIsLoading(true);
    }
  };

  // Filter Email Input
  const onEmailChange = (e) => {
    e.preventDefault();
    e.persist();
    const value = e.target.value.trim();
    let errors = state.errors;
    const emailRegex = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g;
    if (e.target.id === "email_value") {
      if (value === "" || emailRegex.test(value)) {
        errors.email_value = "";
      } else {
        errors.email_value = "Invalid Email Input";
      }
      setState((state) => ({
        ...state,
        [e.target.id]: value,
        errors: errors,
      }));
    }
  };

  const onEmailSubmit = (e) => {
    e.preventDefault();
    editCustomerInfo(state.email_value, transaction_id);
    setIsLoading(true);
  };

  useEffect(() => {
    if (action === "order_posting") {
      setHeader("Are you sure?");
      setHeaderWidth(400);
    } else if (action === "edit_customer") {
      setHeader("Edit Customer Information");
      setHeaderWidth(600);
    }
  }, [action]);

  useEffect(() => {
    if (confirmModal === true) {
      setState({
        email_value: email,
        errors: {
          email_value: "",
        },
      });
    }
    //eslint-disable-next-line
  }, [confirmModal]);

  useEffect(() => {
    if (isLoading === true) {
      if (loading === false) {
        handleClose();
        setIsLoading(false);
      }
    }
    //eslint-disable-next-line
  }, [loading]);

  return (
    <Modal
      open={confirmModal}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      {/* {action === "order_posting" ? () : null} */}{" "}
      <div style={modalStyle} className={classes.paper}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={classes.modalHeader}
        >
          <Grid item>
            <Typography variant="h6"> {header} </Typography>{" "}
          </Grid>{" "}
          <Grid item>
            <IconButton
              aria-label="expand row"
              onClick={handleClose}
              disabled={loading}
            >
              <CloseIcon
                style={{
                  color: "#000000",
                }}
              />{" "}
            </IconButton>{" "}
          </Grid>{" "}
          <Grid item xs={12}>
            <Divider variant="fullWidth" />
          </Grid>{" "}
        </Grid>
        {action === "edit_customer" ? (
          <Grid
            container
            direction="row"
            alignItems="center"
            spacing={2}
            className={classes.modalBody}
          >
            <Grid item xs={10}>
              <TextField
                type="text"
                variant="outlined"
                id="email_value"
                size="small"
                fullWidth
                label="Email Address"
                value={state.email_value}
                onInput={onEmailChange}
                error={state.errors.email_value}
              />{" "}
            </Grid>{" "}
            <Grid item xs={2}>
              <Button
                onClick={onEmailSubmit}
                variant="outlined"
                fullWidth
                disabled={
                  state.errors.email_value ||
                  state.email_value === "" ||
                  state.email_value === email
                }
              >
                {loading ? (
                  <div className="d-flex mx-auto my-auto">
                    <SpinnerSmall />
                  </div>
                ) : (
                  <Fragment> {"Update"} </Fragment>
                )}{" "}
              </Button>{" "}
            </Grid>{" "}
          </Grid>
        ) : null}
        {action === "order_posting" ? (
          <Grid
            container
            direction="row"
            justifyContent="center"
            spacing={3}
            className={classes.modalBody}
          >
            <Grid item>
              <Typography variant="subtitle1">
                You are going to post an order to Shopify.{" "}
              </Typography>{" "}
            </Grid>{" "}
            <Grid item>
              <Button
                onClick={handleClose}
                variant="outlined"
                className={classes.button}
                disabled={loading}
              >
                CANCEL{" "}
              </Button>{" "}
            </Grid>{" "}
            <Grid item>
              <Button
                onClick={onOK}
                variant="outlined"
                className={classes.button}
                disabled={loading}
              >
                {loading ? (
                  <div className="d-flex mx-auto my-auto">
                    <SpinnerSmall />
                  </div>
                ) : (
                  <Fragment> {"OK"} </Fragment>
                )}{" "}
              </Button>{" "}
            </Grid>{" "}
          </Grid>
        ) : null}{" "}
      </div>{" "}
    </Modal>
  );
};

export default PaymentActionModal;
